export default {
	data() {
		return {
			snackbar: false,
			snackbartext: '',
		};
	},

}
